<pagination [listId]="listId"></pagination>
<!-- patch fo sortableJS bug on iOS *ngIf="editMode"-->
<div class="items" [sortablejs]="entries" [sortablejsOptions]="options" *ngIf="editMode">
  <registry-entry [id]="entry.id" [registry]="registry" [category]="category" [entry]="entry" [editMode]="editMode" *ngFor="let entry of entries"></registry-entry>
</div>
<div class="items" *ngIf="!editMode">
  <registry-entry [id]="entry.id" [registry]="registry" [category]="category" [entry]="entry" [editMode]="editMode" *ngFor="let entry of entries"></registry-entry>
</div>
<pagination [listId]="listId"></pagination>
